import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { EquipmentListResponseType, MaterialListResponseType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getMaterialListing = (payload: MaterialListResponseType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getMaterialListing`,
        payload
      );
      dispatch({
        type: action_types.MATERIAL_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.MATERIAL_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removeMaterialListingData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.MATERIAL_LISTING,
      data: { payload: {}, loading: true, count: null },
    });
  };
};

export const getMaterialDetailById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getMaterialDetailById/${id}`);
      dispatch({
        type: action_types.GET_MATERIAL_DETAILS,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_MATERIAL_DETAILS,
        data: { loading: false },
      });
    }
  };
};

export const removeMaterialDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_MATERIAL_DETAILS,
      data: { payload: {}, loading: true },
    });
  };
};

export const getEquipmentListing = (payload: EquipmentListResponseType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getEquipmentListing`,
        payload
      );
      dispatch({
        type: action_types.EQUIPMENT_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.EQUIPMENT_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removeEquipmentListingData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.EQUIPMENT_LISTING,
      data: { payload: {}, loading: true, count: null },
    });
  };
};

export const getEquipmentDetailById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(
        `${baseURL}getEquipmentDetailById/${id}`
      );
      dispatch({
        type: action_types.GET_EQUIPMENT_DETAILS,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_EQUIPMENT_DETAILS,
        data: { loading: false },
      });
    }
  };
};

export const removeEquipmentDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_EQUIPMENT_DETAILS,
      data: { payload: {}, loading: true },
    });
  };
};
